import { createSelector } from '@ngrx/store';
import { getAllotmentsExportState } from '../reducer';
import { AllotmentExportState } from './state';

export const hasAccessAllotmentsTab = createSelector(
  getAllotmentsExportState,
  (state: AllotmentExportState) => state.canAccessAllotments
);

export const getAllotmentsGridExportData = createSelector(
  getAllotmentsExportState,
  (state: AllotmentExportState) => state.exportGridsData
);
